<template>
  <div class="login-container">
    <!-- 背景装饰层 -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
    </div>

    <div class="banner-logo">
      <el-image
          :src="iconlogo"
          fit="fill"></el-image>
    </div>

    <!-- 登录卡片主体 -->
    <div class="login-card">
      <!-- 品牌/标题区域 -->
      <div class="login-header">
        <h1 class="system-title">三沐智联卡系统</h1>
      </div>

      <!-- 登录方式切换标签 -->
      <div class="login-tabs">
        <span 
          class="tab-item" 
          :class="{ active: loginType === 'account' }"
          @click="switchTab('account')"
        >账号登录</span>
      </div>

      <!-- 登录表单 -->
      <el-form 
        :model="loginForm" 
        :rules="loginRules" 
        ref="loginFormRef"
        class="login-form"
        @submit.native.prevent="handleLogin"
      >
        <!-- 账号登录表单 -->
        <template v-if="loginType === 'account'">
          <el-form-item prop="login_name">
            <el-input
              v-model="loginForm.login_name"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              size="medium"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="medium"
              show-password
            ></el-input>
          </el-form-item>
        </template>

        <!-- 提交按钮与辅助操作 -->
        <el-form-item>
          <el-button 
            type="primary" 
            size="medium" 
            native-type="submit"
            class="login-btn"
            :loading="loginLoading"
          >登 录</el-button>
        </el-form-item>

        <div class="login-extra">
          <a href="#" class="forgot-link">忘记密码</a>
          <span class="extra-divider">|</span>
          <span class="other-login-label">其他方式登录</span>
          <div class="social-icons">
            <i class="el-icon-question"></i> <!-- 此处可替换为QQ/微信图标 -->
            <i class="el-icon-s-promotion"></i>
          </div>
        </div>
      </el-form>
    </div>

    <div class="footer">
        <div class="center">
            三沐智联卡系统 | Copyright © 2026-2027 All Rights Reserved | <a href="https://beian.miit.gov.cn/" target="_block">粤ICP备2026105233号</a>
        </div>
      </div>

  </div>
</template>

<script>
import Api from '../api/index'

export default {
  name: 'LoginPage',
  data() {
    return {
      iconlogo: require("@/assets/login-main-B7d9TLm_.svg"),
      loginType: 'account', // account 或 phone
      loginForm: {
        login_name: '',
        password: '',
        phone: '',
        smsCode: ''
      },
      loginRules: {
        login_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码为6位数字', trigger: 'blur' }
        ]
      },
      loginLoading: false,
      smsCountdown: 0,
      countdownTimer: null
    };
  },
  methods: {
    // 切换登录方式
    switchTab(type) {
      this.loginType = type;
      // 切换时清空表单验证状态
      this.$refs.loginFormRef && this.$refs.loginFormRef.clearValidate();
    },
    // 发送短信验证码（模拟）
    sendSmsCode() {
      if (this.loginForm.phone && /^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.success('验证码已发送（模拟）');
        this.startCountdown();
      } else {
        this.$message.warning('请先输入正确的手机号');
      }
    },
    // 倒计时逻辑
    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.smsCountdown = 60;
      this.countdownTimer = setInterval(() => {
        this.smsCountdown--;
        if (this.smsCountdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 登录提交
    handleLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (!valid) return;
        this.loginLoading = true;

        Api.Login(this.loginForm).then(res => {
          this.loginLoading = false;
          if(!res)
            return;
          if(res.code === 200 && res.data) {
            localStorage.setItem("access_token", res.data.token);
            localStorage.setItem("user_name", res.data.userName);
            localStorage.setItem("user_type", res.data.userType);
            localStorage.setItem("service_end", res.data.serviceEnd);

            this.$message.success('登录成功! 正在跳转');
            this.$router.push('sims/manage');
          } else {
            this.$message.warning(`登录失败！${res.msg}`);
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.warning(`出错了！服务器网络似乎有问题！${error}`);
          this.loginLoading = false;
        });
      
      });
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }
};
</script>


<style scoped>
.el-main {
    height: 100vh;
}

.footer {
    position: fixed;
    z-index: 500;
    bottom: 10px;
    left: 0px;
    margin-bottom: 10px;
    text-align: center;
    color: #666666;
    width: 100%;
}

/* 全局样式重置与容器 */
.login-container {
  margin-left: -195px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 92vh;
  background: linear-gradient(135deg, #e0e7ff 0%, #f0f2f5 100%);
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  position: relative;
  overflow: hidden;
}

/* 背景装饰圆形 */
.bg-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.08);
}
.circle-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
}
.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -80px;
  left: -80px;
  background: rgba(64, 158, 255, 0.05);
}

/* 登录卡片 */
.login-card {
  width: 400px;
  padding: 40px 35px 30px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 2;
  transition: all 0.3s ease;
}

/* 头部标题 */
.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.system-title {
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 6px 0;
  letter-spacing: 1px;
}
.system-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
  letter-spacing: 2px;
}

/* 登录方式切换标签 */
.login-tabs {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 28px;
  border-bottom: 1px solid #e8ecf1;
  padding-bottom: 12px;
}
.tab-item {
  font-size: 15px;
  color: #606266;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s;
  position: relative;
}
.tab-item::after {
  content: '';
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #409EFF;
  transition: width 0.3s ease;
}
.tab-item.active {
  color: #409EFF;
  font-weight: 500;
}
.tab-item.active::after {
  width: 100%;
}
.tab-item:hover {
  color: #409EFF;
}

/* 表单样式 */
.login-form {
  margin-top: 8px;
}
.el-form-item {
  margin-bottom: 22px;
}
.el-input__inner {
  border-radius: 8px;
  height: 48px;
  background: #f5f7fa;
  border: 1px solid transparent;
  transition: all 0.3s;
}
.el-input__inner:focus {
  background: #fff;
  border-color: #409EFF;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 4px;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  border: none;
  transition: all 0.3s;
}
.login-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.3);
}

/* 底部辅助区域 */
.login-extra {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 13px;
  color: #909399;
  margin-top: 8px;
}
.forgot-link {
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}
.forgot-link:hover {
  color: #409EFF;
}
.extra-divider {
  margin: 0 10px;
  color: #dcdfe6;
}
.other-login-label {
  margin-right: 10px;
}
.social-icons {
  display: flex;
  gap: 12px;
  font-size: 20px;
  color: #909399;
  cursor: pointer;
}
.social-icons i {
  transition: color 0.2s;
}
.social-icons i:hover {
  color: #409EFF;
}

/* 响应式适配 */
@media (max-width: 480px) {
  .login-card {
    width: 90%;
    padding: 30px 20px;
  }
  .system-title {
    font-size: 24px;
  }
}

.banner-logo {
  z-index: 2;
  margin-right: 40px;
  padding-right: 40px;
  border-right: #cccccc 1px solid;
}

</style>